import type { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '../../template/IconTemplateIPortIcon'
import { CustomIconProps } from '../../types/types'

export const SvgBasket = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="basket">
					<path
						id="Vector 215"
						d="M36.6652 10.6816H7.67969V23.6237C7.67969 25.2805 9.02283 26.6237 10.6797 26.6237H28.131C28.9153 26.6237 29.6272 26.1653 29.9517 25.4513L36.6652 10.6816Z"
						fill="#4A4A4A"
					/>
					<path
						id="Vector 216"
						d="M10.0277 6.33398H3.33203V7.68181C3.33203 9.33866 4.67518 10.6818 6.33203 10.6818H7.67986V23.6238C7.67986 25.2807 9.023 26.6238 10.6799 26.6238H12.0277V8.33398C12.0277 7.22941 11.1323 6.33398 10.0277 6.33398Z"
						fill="url(#paint0_linear_13525_60262)"
					/>
					<circle id="Ellipse 1926" cx="23.6251" cy="30.9728" r="2.89855" fill="#4A4A4A" />
					<ellipse
						id="Ellipse 1927"
						cx="10.5782"
						cy="30.9728"
						rx="2.89855"
						ry="2.89855"
						fill="#4A4A4A"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_13525_60262"
						x1="7.67986"
						y1="6.33398"
						x2="7.67986"
						y2="26.6238"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#568DFE" />
						<stop offset="1" stopColor="#E4EDFC" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
